import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import StaffRoles from './components/staffRoles'


const StaffRolesList = (props) => (

    <Container>
        <StaffRoles {...props} />
    </Container>
);

StaffRolesList.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(StaffRolesList);